// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"76f9d31b","111":"39b0bac1","136":"bf72ec42","171":"35f65de7","250":"ccda1461","431":"4c281512","442":"e58f7993","625":"1e751c52","864":"d42b06fc","935":"7320048a","955":"674e4e43","966":"f3cd1bea","996":"668c62ba"}[chunkId] + ".chunk.js";
};